import { render, staticRenderFns } from "./ReportExpenses.vue?vue&type=template&id=6a8d6cf4"
import script from "./ReportExpenses.vue?vue&type=script&lang=js"
export * from "./ReportExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports